import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { useIsAdmin } from "../hooks/useIsAdmin";

/**
 * Route guard for the admin screens. Sits inside `RequireAuth` (so the
 * user is already authenticated and ESS-verified here) and inside
 * `AppLayout`, so the pending state is a content-area spinner rather
 * than RequireAuth's full-viewport one.
 *
 * The backend is authoritative — /ess/import answers 403 to a non-admin
 * regardless — this only keeps the screens out of reach in the UI.
 */
export default function RequireAdmin({ children }: { children: ReactNode }) {
  const { isAdmin, isLoading } = useIsAdmin();

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!isAdmin) return <Navigate to="/suggestions" replace />;

  return <>{children}</>;
}
